import { useCallback, useEffect, useState } from "react";
import { useRequest } from "../api";
import { getAirportNamesRecord } from "../services/airportsService";

type AirlineCode = string;

export function useAirportNames(codes: string[]) {
  const [airportNames, setAirportNames] = useState<Record<AirlineCode, string>>({});
  const request = useRequest();

  const fetchAirportNames = useCallback(async () => {
    if (Array.isArray(codes) && codes.length > 0) {
      try {
        const filteredCodes = codes.filter((v, i, a) => !!v && a.indexOf(v) === i);
        const airports = await getAirportNamesRecord(request)(filteredCodes);
        setAirportNames(airports);
      } catch (error) {
        setAirportNames({});
      }
    }
  }, [codes, request]);

  useEffect(() => {
    if (codes.length > 0) {
      fetchAirportNames();
    }
  }, [codes, fetchAirportNames]);

  return airportNames;
}
